var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1516",
    "data-name": "Group 1516",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.335,
    height: 6.201,
    viewBox: "0 0 10.335 6.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_back",
    "data-name": "arrow back",
    transform: "translate(10.335) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back-2",
    "data-name": "arrow back",
    d: "M5.168,0a.938.938,0,0,0-.723.31L.31,4.444a1,1,0,0,0,0,1.447,1,1,0,0,0,1.447,0L5.168,2.48,8.578,5.891a1.023,1.023,0,1,0,1.447-1.447L5.891.31A.938.938,0,0,0,5.168,0Z",
    transform: "translate(0 10.335) rotate(-90)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowSelected);
export default __webpack_public_path__ + "static/media/up_arrow_selected.3be16e769958c04d163369074576c19d.svg";
export { ForwardRef as ReactComponent };